<div #map class="w-full h-full"></div>

